import url from 'url';
import api from '../../store/config/api';
import { SEARCH as SEARCH_SCHEMA } from '../../schemas';
import { format } from '../../util/url';
import { transformSearchQuery } from '../../util/search';

export const [
  GET_SEARCH_RESULTS,
  GET_SEARCH_RESULTS_REQUEST,
  GET_SEARCH_RESULTS_SUCCESS,
  GET_SEARCH_RESULTS_FAILURE
] = api.buildTypes('GET_SEARCH_RESULTS');

export function getSearchResultList({
  pageKey,
  assignedTo,
  category,
  editableBy,
  includeFields,
  isArchived,
  limit,
  manuallyStartable,
  owner,
  processID,
  q,
  sort,
  status,
  tableType,
  teamName,
  type,
  viewableBy,
  participatingUsers,
  searchID,
  universalSearch = false,
  text = '',
  schema = SEARCH_SCHEMA
}) {
  let query;

  if (universalSearch) {
    query = {
      ...transformSearchQuery(text),
      pageToken: pageKey
    };
  } else {
    query = {
      ...(pageKey && { pageToken: pageKey }),
      ...(assignedTo && {
        assignedTo: Array.isArray(assignedTo)
          ? assignedTo.join(',')
          : assignedTo
      }),
      ...(category !== undefined && { category }),
      ...(editableBy !== undefined && {
        editableBy: Array.isArray(editableBy)
          ? editableBy.join(',')
          : editableBy
      }),
      ...(includeFields && { includeFields }),
      ...(isArchived !== undefined && { isArchived }),
      ...(limit && { limit }),
      ...(manuallyStartable !== undefined && { manuallyStartable }),
      ...(owner && { owner }),
      ...(processID && { processID }),
      ...(q && { q }),
      ...(sort && { sort }),
      ...(status && status !== 'all' && { status }),
      ...(tableType && { tableType }),
      ...(type && { types: type }),
      ...(viewableBy !== undefined && {
        viewableBy: Array.isArray(viewableBy)
          ? viewableBy.join(',')
          : viewableBy
      }),
      ...(participatingUsers !== undefined && {
        participatingUsers: Array.isArray(participatingUsers)
          ? participatingUsers.join(',')
          : participatingUsers
      })
    };
  }

  const payloadUrl = format({
    pathname: `/teams/${teamName}/search`,
    query
  });

  return {
    type: GET_SEARCH_RESULTS,
    payload: {
      url: payloadUrl,
      schema,
      transform: v => ({
        ...v,
        searchID: searchID || url.parse(payloadUrl, true).search
      }),
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/search.js